<div
    class="mt-filters"
    *ngIf="filterConfig"
    [ngClass]="{ collapsed: isCollapsed }"
>
    <mt-container [title]="'filters' | lang | uppercase">
        <div
            class="collapse-button"
            slot="header-end"
            (click)="toggleCollapse()"
        >
            <em
                class="fa fa-chevron-up"
                [ngClass]="{ rotation: isCollapsed }"
            ></em>
        </div>

        <ng-container slot="content">
            <app-progress-bar
                [visibility]="progressBarState"
            ></app-progress-bar>
            <div
                #filtersContent
                class="filters flex-col"
                [ngClass]="{ 'h-100': !isCollapsed }"
            >
                <div class="flex-row">
                    <filter-date
                        *ngIf="filterConfig.dates"
                        [filter]="filterConfig.dates"
                        (dateChanged)="changeDates($event)"
                    >
                    </filter-date>

                    <filter-shift
                        *ngIf="filterConfig.shift"
                        [filter]="filterConfig.shift"
                        (shiftChanged)="changeShift($event)"
                    >
                    </filter-shift>

                    <filter-machine-type
                        *ngIf="filterConfig.machineType"
                        [filter]="filterConfig.machineType"
                        (machineTypesChanged)="changeMachineType($event)"
                    >
                    </filter-machine-type>

                    <filter-mine
                        *ngIf="filterConfig.mine"
                        [filter]="filterConfig.mine"
                        [machineType]="selectedFilter.machineTypeId"
                        (minesChanged)="changeMine($event)"
                    >
                    </filter-mine>

                    <filter-zone
                        *ngIf="filterConfig.zone"
                        [filter]="filterConfig.zone"
                        (frontLoad)="availableFronts = $event"
                        (zonesChanged)="changeZone($event)"
                    >
                    </filter-zone>

                    <filter-front
                        *ngIf="filterConfig.front"
                        [filter]="filterConfig.front"
                        [allFronts]="availableFronts"
                        [zone]="selectedFilter.zoneId"
                        (frontsChanged)="changeFront($event)"
                    >
                    </filter-front>

                    <filter-operator
                        *ngIf="filterConfig.operator"
                        [filter]="filterConfig.operator"
                        [mine]="selectedFilter.zoneId"
                        [machineType]="selectedFilter.machineTypeId"
                        (operatorsChanged)="changeOperator($event)"
                    >
                    </filter-operator>

                    <filter-machine
                        *ngIf="filterConfig.machineList"
                        [filter]="filterConfig.machineList"
                        [machineType]="selectedFilter.machineTypeId"
                        [mine]="selectedFilter.zoneId"
                        (machinesChanged)="changeMachine($event)"
                    >
                    </filter-machine>
                    <filter-all-mine
                        *ngIf="filterConfig.allMine"
                        [filter]="filterConfig.allMine"
                        (allMinesChanged)="changeAllMine($event)"
                    >
                    </filter-all-mine>
                </div>

                <div class="filter-end flex-row">
                    <div class="mandatory-text">
                        <span class="mandatory">*</span>
                        {{ "mandatory fields" | lang }}
                    </div>

                    <div class="flex-row buttons">
                        <app-button
                            *ngIf="filterConfig.cleanButton"
                            class="cancel shadowed rounded"
                            text="{{ 'clear-filter' | lang }}"
                            (clickHandler)="clearFilter()"
                        >
                        </app-button>

                        <app-button
                            [disabled]="!filterForm.valid || (filterButtonDisabled$ | async)"
                            [spinner]="progressBarState"
                            class="action rounded shadowed ml-60"
                            [text]="
                                (filterConfig.filterButton &&
                                filterConfig.filterButton.text
                                    ? filterConfig.filterButton.text
                                    : 'generate'
                                ) | lang
                            "
                            (clickHandler)="filter()"
                        >
                        </app-button>

                        <div
                            class="filter-tooltip"
                            *ngIf="
                                filterConfig.filterButton &&
                                filterConfig.filterButton.tooltip
                            "
                        >
                            <img
                                appImageSelector
                                alt="mt-image"
                                imageType="icon"
                                imageKey="info"
                                [ngbTooltip]="filterConfig.filterButton.tooltip"
                                class="tooltip-info"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </mt-container>
</div>
